<div class="nxe-icons" nxeDragDrop (dragging)="dragging = $event">
  <div class="nxe-icons-drag" [ngClass]="{ dragging: dragging }"></div>
  <div class="nxe-icons-backpad" (click)="emptySpaceClick()"></div>
  <div class="nxe-icons-container drop-list_ pp0" [id]="parentItem.id+''"
       [class.dragging-element]="draggingelement"
       cdkDropList
       [cdkDropListConnectedTo]="connectedIds"
       cdkDropListSortingDisabled
  >
    @if (parentObj) {
      <!-- Cartella superiore: risale di un livello ed è anche zona di rilascio -->
      <div class="drop-list-folder nxe-card-slot">
        <div class="drop drop-list drop-zone pp1" [id]="parentObj.id+''"
             cdkDropList
             [cdkDropListData]="parentObj"
             [cdkDropListConnectedTo]="connectedButMe(parentObj)"
             (cdkDropListDropped)="onDragDropParent($event,parentObj)">
        </div>
        <div class="nxe-icons-wrapper" (dblclick)="open($event, parentObj)" (click)="folderClick($event, parentObj)"
             [id]="'parentDroplist_'+parentObj.id" cdkDrag [cdkDragDisabled]="isSelected(parentObj)">
          <div class="nxe-icons-wrapper-inner nxe-card nxe-card--up" [ngClass]="{ 'nxe-icon-selected': isSelected(parentObj) }"
               [title]="'filemanager.ui.parent_folder' | translate">
            <div class="nxe-icons-icon nxe-kind nxe-kind--folder">
              <i-tabler class="icon-24" name="arrow-up"></i-tabler>
            </div>
            <div class="nxe-icon-text">{{ 'filemanager.ui.parent_folder' | translate }}</div>
            <div class="nxe-card-meta">{{ parentObj.parentId ? (parentObj.name | nxeFolderName) : ('filemanager.ui.root' | translate) }}</div>
          </div>
        </div>
      </div>
    }

    @for (item of items; track $index) {
      @if (item.isLeaf) {
        <div class="drag-item nxe-icons-wrapper drop-list nxe-card-slot" [id]="item.id" (dblclick)="open($event, item)"
             (click)="select($event, item)" (cdkDragStarted)="onDragStart($event, item)" [cdkDragData]="selectedNodes"
             cdkDrag>
          <div class="nxe-icons-wrapper-inner nxe-card" [ngClass]="{ 'nxe-icon-selected': isSelected(item) }"
               [title]="item.name">
            <div class="nxe-icons-icon nxe-kind" [ngClass]="'nxe-kind--' + fileKind(item).tone" cdkDragHandle>
              {{ fileKind(item).label }}
            </div>
            <div class="nxe-icon-text">{{ item.name }}</div>
            @if (fileMeta(item); as meta) {
              <div class="nxe-card-meta">{{ meta }}</div>
            }
            @if (isRagSupported(item)) {
              <div class="rag-mini" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
                <span class="xr-badge" [ngClass]="ragBadgeClass(item)" [title]="ragStatusTitle(item)">
                  @if (isRagProcessing(item)) {
                    <i-tabler class="icon-14 rag-spin" name="loader-2"></i-tabler>
                  }
                  {{ ragStatusLabel(item) }}
                </span>
                @if (canSendToRag(item)) {
                  <button type="button" class="xr-btn xr-btn--soft xr-btn--icon rag-btn rag-btn--send"
                          [attr.aria-label]="ragSendLabel(item)"
                          [matTooltip]="ragSendLabel(item)" matTooltipPosition="above"
                          (click)="sendToRag($event, item)">
                    <i-tabler class="icon-18" name="brain"></i-tabler>
                  </button>
                }
                @if (canRemoveFromRag(item)) {
                  <button type="button" class="xr-btn xr-btn--soft xr-btn--icon rag-btn rag-btn--remove"
                          [attr.aria-label]="ragRemoveLabel()"
                          [matTooltip]="ragRemoveLabel()" matTooltipPosition="above"
                          (click)="removeFromRag($event, item)">
                    <span class="brain-off">
                      <i-tabler class="icon-16" name="brain"></i-tabler>
                      <i-tabler class="icon-16 slash" name="slash"></i-tabler>
                    </span>
                  </button>
                }
              </div>
            }
          </div>
          <div *cdkDragPreview>
            @for (node of selectedNodes; track $index) {
              <div class="drag-item-preview">
                <i-tabler class="icon-24 icon-file" [name]="'file'"></i-tabler>
                <span class="nxe-icon-text">{{ node.name }}</span>
              </div>
            }
          </div>
          <div class="nxe-icon-placeholder" *cdkDragPlaceholder></div>
        </div>
      }
      @if (!item.isLeaf) {
        <div class="drop-list-folder nxe-card-slot">
          <div class="nxe-icons-wrapper" [id]="'folder-'+item.id" (dblclick)="open($event, item)"
               (click)="folderClick($event, item)"
               (cdkDragStarted)="onDragStart($event, item)" [cdkDragData]="selectedNodes" cdkDrag>
            <div class="nxe-icons-wrapper-inner nxe-card" [ngClass]="{ 'nxe-icon-selected': isSelected(item), 'nxe-card--archive': isArchiveRoot(item) }"
                 [title]="item.name | nxeFolderName">
              <div class="nxe-icons-icon nxe-kind nxe-kind--folder" cdkDragHandle>
                <i-tabler class="icon-26 nxe-folder-glyph" name="folder"></i-tabler>
              </div>
              <div class="nxe-icon-text">{{ item.name | nxeFolderName }}</div>
              @if (fileMeta(item); as meta) {
                <div class="nxe-card-meta">{{ meta }}</div>
              }
            </div>
            <div *cdkDragPreview>
              @for (node of selectedNodes; track $index) {
                <div class="drag-item-preview">
                  <i-tabler class="icon-24 icon-file" [name]="'folder-filled'"></i-tabler>
                  <div class="nxe-icon-text">{{ node.name | nxeFolderName }}</div>
                </div>
              }
            </div>
            <div class="nxe-icon-placeholder" *cdkDragPlaceholder></div>
          </div>
          <div class="drop drop-list drop-zone pp3" [id]="item.id+''"
               cdkDropList
               [cdkDropListData]="item"
               [cdkDropListConnectedTo]="connectedButMe(item)"
               (cdkDropListDropped)="onDragDrop($event,item)">
          </div>
        </div>
      }
    }

    @if (!items.length) {
      <div class="xr-empty nxe-empty">{{ 'filemanager.ui.empty' | translate }}</div>
    }
  </div>
</div>
